import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Picture } from '@components/Picture';
import { Points } from '@styles';

export const ComplexMaterial = () => {
  const translations = useTranslations();

  const data = {
    '670': [`/images/mainpage/complex-material-1x.png`, `/images/mainpage/complex-material-1x.webp`],
    '1x': [`/images/mainpage/complex-material-1x.png`, `/images/mainpage/complex-material-1x.webp`],
    '2x': [`/images/mainpage/complex-material-2x.png`, `/images/mainpage/complex-material-2x.webp`],
  };

  return (
    <View>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.complex-material.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.complex-material.description')} />
        <PictureWrapper>
          <Picture
            data={data}
            alt={translations.t('site.home.opportunities.complex-material.alt')}
            lazy={false}
            width="100%"
            height="100%"
          />
        </PictureWrapper>
      </Content>
    </View>
  );
};

const View = styled.div`
  padding: 16px 16px 40px;
  color: ${Colors.main_black};
  background-color: ${Colors.white};
  border-radius: 15.13px;

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 40px;
  }

  @media ${Points.laptop_wide} {
    padding: 40px 40px 50.6px;
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    gap: 20px;
  }
`;

const PictureWrapper = styled.div`
  margin-top: 70px;

  @media ${Points.tablet_landscape} {
    margin-top: 40px;
  }

  @media ${Points.laptop_wide} {
    margin-top: 80px;
`;
